type AdvancedMarkerElement = google.maps.marker.AdvancedMarkerElement;

class LocationMap {
    private readonly map: google.maps.Map;
    private readonly infoWindow = new google.maps.InfoWindow();

    constructor(private readonly mapElement: HTMLElement) {
        this.map = new google.maps.Map(mapElement, {
            maxZoom: 17,
            mapId: mapElement.getAttribute('data-map-id'),
            zoomControl: true,
            scaleControl: true,
            mapTypeControl: false,
            streetViewControl: false
        });
        
        // Small delay to ensure DOM is ready
        setTimeout(() => this.setupMarker(), 100);
    }

    private async setupMarker() {
        try {
            const {AdvancedMarkerElement} = await google.maps.importLibrary('marker') as google.maps.MarkerLibrary;
            
            // Fetch and prepare the SVG icon
            const basePin = await fetch(new URL('/wp-content/themes/plaudit-theme-child/blocks/LocationMap/map-marker.svg', document.baseURI))
                .then(icon => {
                    if (!icon.ok) {
                        throw new Error("Unable to download the map marker");
                    }
                    return icon.text();
                })
                .then(icon => new DOMParser().parseFromString(icon, 'image/svg+xml').documentElement);

            // Get data directly from the map element
            const {lat, lng, locationType, title, address, phone, hasUrgentCare} = this.mapElement.dataset;
            if (!lat || !lng) {
                console.warn('Map element missing lat/lng data');
                return;
            }

            // Fix the SVG and set color based on type
            const path = basePin.querySelector('path');
            if (path) {
                const fillColor = locationType === 'urgent-care' ? '#E0312B' : '#7923b5';
                path.setAttribute('fill', fillColor);
            }

            // Remove any transparent rectangles that might interfere
            const transparentRect = basePin.querySelector('rect[opacity="0"]');
            if (transparentRect) {
                transparentRect.remove();
            }

            const position = {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            };

            const icon = basePin.cloneNode(true) as Element;
            icon.setAttribute('data-type', locationType || 'default');

            const marker = new AdvancedMarkerElement({
                position,
                content: icon,
                map: this.map
            });

            // Add click listener to show info window
            marker.addListener('click', () => {
                let infoContent = `<div class="locationMap__infoWindowContent">
                    <h3>${title || 'Location'}</h3>
                    <div class="location-info">
                        ${address || ''}`;
                
                if (phone) {
                    const cleanPhone = phone.replace(/[^0-9]/g, '');
                    infoContent += `<br><a href="tel:${cleanPhone}">${phone}</a>`;
                }
                
                if (hasUrgentCare === '1') {
                    infoContent += `<br><span class="urgent-care-indicator">Orthopedic Urgent Care</span>`;
                }
                
                infoContent += `</div></div>`;
                
                this.infoWindow.setContent(infoContent);
                this.infoWindow.open(this.map, marker);
            });

            // Center the map on the single location with appropriate zoom
            this.map.setCenter(position);
            this.map.setZoom(15);
            
        } catch (error) {
            console.error('Error setting up location map:', error);
        }
    }
}

document.addEventListener('plauditBase__mapInitialized', () => {
    document.querySelectorAll<HTMLElement>('.location-map').forEach(element => {
        if (!element.classList.contains('location-map--setup')) {
            element.classList.add('location-map--setup');
            new LocationMap(element);
        }
    });
});
